<mat-toolbar class="header">
    <button
        [matMenuTriggerFor]="menu"
        aria-label="Menu btn with icon"
        mat-icon-button
    >
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <a
            mat-menu-item
            routerLink="/"
        >
            <mat-icon>apps</mat-icon>
            <span>Publikacje</span>
        </a>
        <a
            mat-menu-item
            routerLink="/copy"
        >
            <mat-icon>sync_alt</mat-icon>
            <span>Kopiuj</span>
        </a>
    </mat-menu>
    <span>{{ name }}</span>
    <span class="spacer"></span>
    <div class="header-right-panel">
        <span>{{ (user$ | async)?.name }} </span>

        <button
            (click)="onSingOutClick()"
            class="btn"
            id="login-btn"
            mat-flat-button
            name="login-btn"
            type="button"
        >
            <mat-icon>logout</mat-icon>
            Wyloguj
        </button>
    </div>
</mat-toolbar>
